import { gateway } from "src/gateway";

export type TPublicBillingMethodType = "card" | "paypal" | "unknown";

export type TPublicServiceBillingVault = {
  id: string;
  subscriptionId: string;
  provider: "paypal" | "stripe";
  status: string;
  methodType: TPublicBillingMethodType;
  brand: string | null;
  lastDigits: string | null;
  expiry: string | null;
  paypalEmail: string | null;
  paypalAccountName: string | null;
  currencyCode: string;
  activatedAt: string | null;
  lastSuccessfulChargeAt: string | null;
};

export const apiGetCompanyBillingVaults = async (): Promise<TPublicServiceBillingVault[]> => {
  const response = await gateway.get("/subscriptions/billing-vaults");
  return response?.data?.data ?? [];
};

export const formatPublicBillingMethod = (vault?: TPublicServiceBillingVault | null): string | null => {
  if (!vault) return null;

  if (vault.methodType === "card" && vault.lastDigits) {
    const brand = vault.brand || "Card";
    return vault.expiry ? `${brand} •••• ${vault.lastDigits} · ${vault.expiry}` : `${brand} •••• ${vault.lastDigits}`;
  }

  if (vault.methodType === "paypal" || vault.provider === "paypal") {
    if (vault.paypalEmail) return `PayPal · ${vault.paypalEmail}`;
    if (vault.paypalAccountName) return `PayPal · ${vault.paypalAccountName}`;
    if (vault.methodType === "card") return vault.brand ? `${vault.brand} card` : "Card on file";
    return "PayPal";
  }

  if (vault.provider === "stripe") return vault.brand ? `${vault.brand} card` : "Card on file";

  return "Payment method on file";
};

export const formatCompactBillingMethod = (vault?: TPublicServiceBillingVault | null): string | null => {
  if (!vault) return null;

  if (vault.methodType === "card" && vault.lastDigits) {
    const brand = vault.brand || "Card";
    return `${brand} •••• ${vault.lastDigits}`;
  }

  if (vault.methodType === "paypal" || vault.provider === "paypal") {
    if (vault.paypalEmail) return `PayPal (${vault.paypalEmail})`;
    return "PayPal";
  }

  if (vault.provider === "stripe") return vault.brand ? `${vault.brand} card` : "Card on file";

  return "Payment method on file";
};
